<template lang="html">
  <div class="col-lg-9 col-page-content page-messages">
    <div class="row">

      <div class="col-12">
        <div class="box-bubble">
          <div class="row">

            <div class="col-12 box-acc-title-s1">
              <h4>Mensajes</h4>
              <hr />
            </div>

            <div class="col-12 messages-container">
              <div class="row">

                <!-- User messages -->
                <!-- <div class="col-lg-4 col-users-messages">
                  <div class="row">

                    <div class="col-12 box-form">
                      <b-form @submit="onSubmitSearch">
                        <b-form-input
                          v-model="formSearch.keywords"
                          type="text"
                          placeholder="Buscar usuario"
                          required
                        ></b-form-input>

                        <b-button type="submit" class="btn-search"><i class="fas fa-search"></i></b-button>
                      </b-form>
                    </div>

                    <div class="col-12 box-user-messages">
                      <div class="box-message" v-bind:class="{ active: msgInx == 1 }" v-for="(msg, msgInx) in 10" :key="'msgInx-'+msgInx">
                        <div class="col col-photo">
                          <div class="placed-backg photo" v-bind:style="{ backgroundImage: 'url(public/images/pages/users/profile-4.jpg)' }"></div>
                        </div>

                        <div class="col col-message">
                          <h6 class="name">Stefany Bosch</h6>
                          <div class="box-msg">
                            <p>
                              ¿Te parece bien el Lunes despues de las 4:00 p.m. en la sucurscal de Gran Plaza?
                            </p>
                          </div>
                        </div>

                        <div class="col-12 col-date">
                          <h6>Marzo 4</h6>
                        </div>
                      </div>
                    </div>

                  </div>
                </div> -->
                <!--  -->

                <!-- Opened Message -->
                <div class="col-lg-12 col-messages">
                  <!-- <div class="box-selected-user-name">
                    Stefany Bosch
                  </div> -->
                  <div class="box-selected-user-msgs" v-if="$root.user.messages.length == 0">
                      <p>No has recibido ningun mensaje</p>
                  </div>
                  <div class="box-selected-user-msgs" style="height:auto !important;" v-else>
                    <div class="content" id="responses-wr">

                      <div class="box-response" v-for="(msg, respInx) in $root.user.messages" :key="'respInx-'+respInx">
                        <div class="row-resp">
                          <div class="col-12 col-date">
                            <h6>Fecha de mensaje: {{ msg.creado }}</h6>
                          </div>

                          <div class="col col-photo">
                            <div class="placed-backg photo" v-bind:style="{ backgroundImage: 'url('+msg.img+')' }"></div>
                          </div>

                          <div class="col col-response">
                            <h6><span class="name">{{ msg.nombre }} {{respInx}}</span><!--  - <span class="date">12:30 pm</span> --></h6>

                            <div class="box-resp" v-html="msg.msg"></div>
                            <br>
                            <a :href="'mailto:'+msg.email" class="btn-msg"><span>Enviar mensaje</span></a>
                            <div class="box-resp">Vacante: <b>{{msg.vacant}}</b></div>
                            <div class="box-resp">Fecha de publicación: <b>{{msg.vacant_date}}</b></div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                 <!--  <div class="box-response-form">
                    <b-form @submit="onSubmitResp">
                      <b-form-group>
                        <b-form-textarea
                          v-model="formResp.msg"
                          placeholder="Escribe tu mensaje"
                          rows="2"
                          max-rows="2"
                        ></b-form-textarea>
                      </b-form-group>

                      <p class="text-right">
                        <b-button type="submit" class="btn-cur-1 sm">enviar</b-button>
                      </p>
                    </b-form>
                  </div> -->
                </div>
                <!--  -->

              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      formSearch: {
        keywords: null,
      },

      formResp: {
        msg: null
      },

      ejemploArrayMsg: [
        { img: 'public/images/pages/jobs/logo-1.png', name: 'Insumos Quirúrgicos', date: 'Marzo 5', msg: `<p>Hola buenos días,<br /> Esto es un mensaje de prueba de la cuenta empresa.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 4', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 4', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 4', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 4', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 4', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 4', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 4', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 4', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
        { img: 'public/images/pages/users/profile-4.jpg', name: 'Stefany Bosch', date: 'Marzo 3', msg: `<p>Hola buen día,<br /> Con mucho gusto, actualmente estoy laborando en una empresa , sin embargo, me gustaría proyectarme profesionalmente, si es necesario que envíe algun archivo adicional al Curribulum de mi perfil público con gusto puedo hacerlo.</p>` },
      ],
    }
  },

  methods: {
    onSubmitSearch(event) {
      event.preventDefault();
    },

    onSubmitResp(event) {
      event.preventDefault();

      // Detectar y agregar <br /> a los saltos de linea
      var resp = this.formResp.msg.replace(/\n\r?/g, '<br />');

      // Scroll hasta abajo del contenedor de mensajes
      var element = document.getElementById("responses-wr");
      element.scrollTop = element.scrollHeight;


      // AQUI X codigo para guardar en la BD con solo enters como html


      // Agregar el mensaje al inicio del array para que se muestre en el front
      this.ejemploArrayMsg.unshift({ img: 'public/images/pages/jobs/logo-1.png', name: 'Insumos Quirúrgicos', date: 'Marzo 7', msg: resp })
      this.formResp.msg = null;
    }
  },
}
</script>
